const unixToISO = (epochSeconds) => (new Date(epochSeconds * 1000)).toISOString();

export default unixToISO;
